import { createContext, useCallback, useState } from 'react';

const DEFAULT_OPEN_KEY: any[] = [];
const DEFAULT_SELECTED_KEY = ['11'];

interface DefaultContextSider {
  openKey: any[];
  updateOpenKey: (data: any[]) => void;
  selectedKey: any[];
  updateSelectedKey: (data: any[]) => void;
}

const DEFAULT_CONTEXT: DefaultContextSider = {
  openKey: DEFAULT_OPEN_KEY,
  updateOpenKey: (data: any[]) => {},
  selectedKey: DEFAULT_SELECTED_KEY,
  updateSelectedKey: (data: any[]) => {},
};

export const SiderContext = createContext(DEFAULT_CONTEXT);

export function useSiderContext(): DefaultContextSider {
  const [openKey, setOpenKey] = useState(DEFAULT_OPEN_KEY);
  const [selectedKey, setSelectedKey] = useState(DEFAULT_SELECTED_KEY);
  const updateOpenKey = useCallback((data): void => {
    setOpenKey(data);
  }, []);

  const updateSelectedKey = useCallback((data): void => {
    setSelectedKey(data);
  }, []);

  return {
    openKey,
    updateOpenKey,
    selectedKey,
    updateSelectedKey,
  };
}
